export const loginUrl = '/';
export const dashboardUrl = '/';
export const onboardingUrl = '/onboarding';

export const channelUrl = '/channels/:token';

export const directMessagesUrl = '/messages';
export const directMessageUrl = '/messages/:token';

export const songsUrl = '/songlist';
export const setlistsUrl = '/setlists';
export const reportsUrl = '/reports';

export const reelsUrl = '/reels';
export const videoUrl = '/videos/:token';
export const acceptInviteUrl = '/accept-invite/:token';
export const inviteLinkUrl = '/i/:token';
export const authorProfileUrl = '/authors/:authorId';
export const libraryUrl = '/library';

export const adminUrl = '/admin';

// Co-pilot
export const copilotUrl = '/copilot';

// App Store
export const appStoreUrl =
	'https://apps.apple.com/us/app/asaph/id1627409052?platform=iphone';
export const googlePlayUrl =
	'https://play.google.com/store/apps/details?id=io.asaph';
